// extracted by mini-css-extract-plugin
export default {"newAddress":"NewAddressOption-module__newAddress___BlAM8"};